export const EXPIRED_APP_BLOCKER_ROUTE = 'expired_app';
export const PROVIDER_WAITLIST_ROUTE = 'provider.waitlist';
export const HOME_ROUTE = 'home';
export const SALON_ROUTE = 'salon';
export const PROFILE_ROUTE = 'profile';
export const PROFILE_EDIT_ROUTE = 'profile_edit';
export const PROFILE_EDIT_SERVICE_INFO_ROUTE = `${PROFILE_EDIT_ROUTE}.service_info`;
export const PROVIDER_SEARCH_RANK = 'provider.search_rank';
export const PROVIDER_SEARCH_RANK_NEW_CLIENTS = 'provider.search_rank_new_clients';
export const PROVIDER_SEARCH_RANK_PAYMENTS = 'provider.search_rank_payments';
export const BOOKING_ROUTE = `${PROFILE_ROUTE}.book`;
export const BOOKING_SUCCESS_ROUTE = `${PROFILE_ROUTE}.booking.confirmation`;
export const PROVIDER_MARKETING_HUB = 'provider.marketing_hub';
const PROVIDER_RESPONSIVE = 'responsive.provider';
export const PROVIDER_CLIENT_NOTE = `${PROVIDER_RESPONSIVE}.client_note`;
export const PROVIDER_EDIT_REVIEWS = `${PROVIDER_RESPONSIVE}.ratings_reviews`;
export const PROVIDER_FEES = 'provider.fees';
export const CLIENT_APPTS_LIST = 'consumer.appointments';
export const CLIENT_APPTS_LIST_DEFAULT = `${CLIENT_APPTS_LIST}.list`;
export const CLIENT_APPTS_LIST_FUTURE = `${CLIENT_APPTS_LIST}.future`;
export const ADJUST_TIP = 'consumer.adjust-tip';
export const ADJUST_TIP_THANK_YOU = 'consumer.adjust-tip.thank-you';
export const ADJUST_TIP_DEFAULT = 'consumer.adjust-tip.default';
export const ADJUST_TIP_REFUNDED = 'consumer.adjust-tip.refunded';
export const CLIENT_PAYMENT_REQUEST_CHECKOUT = 'client.payment_request_checkout.checkout';
export const CLIENT_FILL_SCHEDULE_GAP_ROUTE = 'client.fill_schedule_gap';
export const CLIENT_INVITED_TO_BOOK = 'consumer.invited_to_book';
export const CHAT = 'chat';

// Provider settings
const PROVIDER_SETTINGS = 'provider.settings_menu';
export const PROVIDER_SETTINGS_ONLINE_BOOKING_MENU = `${PROVIDER_SETTINGS}.online_booking`;
export const PROVIDER_SETTINGS_PAYMENTS_MENU = `${PROVIDER_SETTINGS}.payments`;
export const PROVIDER_SETTINGS_SOCIAL = `${PROVIDER_SETTINGS}.social`;
export const PROVIDER_SETTINGS_ONLINE_BOOKING = `${PROVIDER_SETTINGS_ONLINE_BOOKING_MENU}.online_booking`;
export const PRO_PERSONAL_INFO_SETTINGS = `${PROVIDER_RESPONSIVE}.settings_personal`;
export const PRO_BUSINESS_INFO_SETTINGS = `${PROVIDER_RESPONSIVE}.settings_salon`;
export const PRO_TAPTOPAY_ONBOARD_SETTINGS = `${PROVIDER_SETTINGS}.tap_to_pay_setup`;
export const PRO_TAPTOPAY_ONBOARD_SETTINGS_DEEP_LINK = 'deep_link_tap_to_pay_setup';
export const PRO_NOTIFICATION_SETTINGS_SUBMENU = `${PROVIDER_SETTINGS}.notification_settings`;
export const PRO_NOTIFICATION_SETTINGS = `${PROVIDER_SETTINGS}.pro_notification_settings`;
export const PRO_CLIENT_NOTIFICATION_SETTINGS = `${PROVIDER_SETTINGS}.client_notification_settings`;
export const PROVIDER_SETTINGS_FRONT_DESK = `${PROVIDER_SETTINGS}.front_desk`;

// schedule settings
export const PRO_MANAGE_SCHEDULE = `${PROVIDER_RESPONSIVE}.schedule`;
export const PRO_MANAGE_ONGOING_SCHEDULE = `${PROVIDER_RESPONSIVE}.availability`;
export const PRO_ADJUST_UPCOMING_HOURS = `${PRO_MANAGE_SCHEDULE}.upcoming`;
export const PRO_MANAGE_VACATION = `${PRO_MANAGE_SCHEDULE}.vacation`;

// Client Account Settings
export const CLIENT_ACCOUNT_SETTINGS_ROUTE = 'consumer.account';
export const CLIENT_PROMOTIONS_LIST_ROUTE = `${CLIENT_ACCOUNT_SETTINGS_ROUTE}.promotions_list`;
export const CLIENT_CONTACT_INFORMATION_ROUTE = `${CLIENT_ACCOUNT_SETTINGS_ROUTE}.profile`;
export const CLIENT_PAYMENT_METHOD_PARENT = `${CLIENT_ACCOUNT_SETTINGS_ROUTE}.user_credit_card`;
export const CLIENT_PAYMENT_METHOD_LIST = `${CLIENT_PAYMENT_METHOD_PARENT}.list`;
export const CLIENT_PAYMENT_METHOD_ADD = `${CLIENT_PAYMENT_METHOD_LIST}.add`;
export const CLIENT_PAYMENT_METHOD_DETAIL = `${CLIENT_PAYMENT_METHOD_PARENT}.detail`;
export const CLIENT_CHANGE_PASSWORD_ROUTE = `${CLIENT_ACCOUNT_SETTINGS_ROUTE}.change_password`;
export const CLIENT_DEFAULT_TIP_SETTING_ROUTE = `${CLIENT_ACCOUNT_SETTINGS_ROUTE}.edit_default_tip`;
export const TRACKED_CLIENT_SIGNUP = 'consumer.trackedsignup';

// Pro appointment management routes
export const CALENDAR_ROUTE = 'provider.calendarNext';
export const PRO_CALENDAR_VIEW_APPOINTMENT = `${CALENDAR_ROUTE}.appointment`;
export const PRO_CALENDAR_NEW_APPOINTMENT = `${CALENDAR_ROUTE}.new`;
export const PRO_CALENDAR_EDIT_APPOINTMENT = `${PRO_CALENDAR_VIEW_APPOINTMENT}.edit`;
export const PRO_CALENDAR_REFUND_APPOINTMENT = `${PRO_CALENDAR_VIEW_APPOINTMENT}.refund`;
export const PRO_PERSONAL_APPOINTMENT_VIEW = `${CALENDAR_ROUTE}.personal_appointment`;
export const PRO_PERSONAL_APPOINTMENT_EDIT = `${PRO_PERSONAL_APPOINTMENT_VIEW}.edit`;

export const PRINTABLE_CALENDAR_ROUTE = 'printCalendar';

// Pro service management routes
export const PRO_MANAGE_SERVICES = `${PROVIDER_RESPONSIVE}.manage_services`;
export const PRO_ADD_SERVICES_AND_CATEGORIES = `${PRO_MANAGE_SERVICES}.add_services_and_categories`;
export const PRO_ADD_SERVICE = `${PROVIDER_RESPONSIVE}.services.add_services`;

// pro photos
export const PRO_IMAGE_LIST = `${PROVIDER_RESPONSIVE}.images`;

// Pro client management routes
export const PRO_CLIENT_BASE = 'provider.client';
export const PRO_CLIENT_LIST = `${PRO_CLIENT_BASE}.list`;
export const PRO_CLIENT_VIEW = `${PRO_CLIENT_LIST}.view`;
export const PRO_CLIENT_VIEW_APPOINTMENT = `${PRO_CLIENT_VIEW}.appointment`;
export const PRO_CLIENT_IMPORT = `${PRO_CLIENT_LIST}.import`;
export const PRO_CLIENT_VIEW_APPOINTMENTS = `${PRO_CLIENT_VIEW}.appointments`;

// Legal Routes for All Users
export const USER_DEPENDENT_LEGAL = 'user_dependent_legal';
export const USER_INDEPENDENT_LEGAL = 'user_independent_legal';
